import { useState, useEffect, useMemo } from 'react';
import { BottomSheetHeader, ScrollableList } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useTutorialVideos } from "../../../../hooks/useTutorialVideos/useTutorialVideos";
import styles from "./MobileTutorialVideos.module.scss";
import { TutorialVideosPlayedVideo } from "./TutorialVideosPlayedVideo";
import { VideoCardItem } from "./VideoCardItem/VideoCardItem";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const getMobileTutorialVideosTID = () => getTestIds();
export function MobileTutorialVideos() {
  const {
    MobileTutorialVideosTID
  } = useMemo(() => getMobileTutorialVideosTID(), []);
  const {
    videos,
    handleWatch
  } = useTutorialVideos();
  const [currentVideo, setCurrentVideo] = useState(null);
  useEffect(() => {
    if (videos.length > 0 && !currentVideo) {
      setCurrentVideo(videos[0]);
    }
  }, [currentVideo, videos]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    "data-testid": MobileTutorialVideosTID.Root(),
    children: [/*#__PURE__*/_jsx(BottomSheetHeader, {
      title: "Explore tutorials",
      paddingBottom: 8
    }), currentVideo && /*#__PURE__*/_jsx("div", {
      className: styles.responsivePlayer,
      children: /*#__PURE__*/_jsx(TutorialVideosPlayedVideo, {
        video: currentVideo,
        onWatch: handleWatch
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.videoSliderContainer,
      children: /*#__PURE__*/_jsx(ScrollableList, {
        direction: "vertical",
        maxSize: "100%",
        gap: 8,
        className: styles.scrollableList,
        children: videos.map(video => /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(VideoCardItem, {
            video: video,
            onSelect: setCurrentVideo,
            isActive: (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id) === video.id,
            variant: "mobile"
          })
        }, video.id))
      })
    })]
  });
}